import { render, staticRenderFns } from "./InformeRepresentante.vue?vue&type=template&id=31fd9165&"
import script from "./InformeRepresentante.vue?vue&type=script&lang=js&"
export * from "./InformeRepresentante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VIcon})
